import { InjectionToken } from '@angular/core';
import { FirebaseApp, FirebaseOptions } from '@angular/fire/app';
import { Messaging } from '@angular/fire/messaging';

export namespace NFirebase {
    /**
     * Global Firebase configuration
     */
    export interface IOptions extends FirebaseOptions {
        vapidKey?: string;
    }

    export interface IData {
        userToken?: string;
    }

    /**
     * Firebase Cloud Messaging payload structure
     * Based on official FCM documentation
     */
    export interface IFCMPayload {
        notification?: {
            title?: string;
            body?: string;
            icon?: string;
            image?: string;
            badge?: string;
            sound?: string;
            tag?: string;
            color?: string;
            click_action?: string;
        };
        data?: {
            [key: string]: string;
        };
        from?: string;
        collapseKey?: string;
        messageId?: string;
    }

    export enum EPermission {
        Granted = 'granted',
        Denied = 'denied',
        Default = 'default'
    }

    export enum EEndpoints {
        FirebaseSunbscribe = 'pushNotifications/subscribe'
    }
}

export interface BeforeInstallPromptEvent extends Event {
    prompt(): void;
}

export const PROVIDED_FIREBASE_APPS = new InjectionToken<Array<FirebaseApp>>('PROVIDED_FIREBASE_APPS');

export const PROVIDED_MESSAGING_INSTANCES = new InjectionToken<Messaging[]>('PROVIDED_MESSAGING_INSTANCES');
